@import 'styles/mixins';
@import 'styles/blaze/mixins';

.eventContainer {
  @include transition;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--dark-8);
  background: var(--light-100);
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  position: relative;
  width: var(--card-width);
  min-width: 185px;

  &.canOpenPreview {
    cursor: pointer;
  }

  &.new {
    border: 1px solid rgba(234, 75, 248, 0.5);
    box-shadow: 0px 0px 10px 0px rgba(237, 36, 255, 0.15) inset, 0px 2px 10px 0px rgba(0, 0, 0, 0.06);

    &.isV2 {
      border: 1px solid #d800ec;
      box-shadow: none;
    }
  }

  &.failed {
    border: 1px solid rgba(188, 1, 11, 0.3);
    box-shadow: 0px 0px 44px 0px rgba(251, 0, 13, 0.13) inset, 0px 2px 10px 0px rgba(0, 0, 0, 0.06);

    &.isV2 {
      border: 1px solid var(--red-90);
      box-shadow: none;
    }

    .eventPreview,
    .eventHeader {
      opacity: 0.4;
    }
  }

  &.posted {
    border: 1px solid rgb(7, 148, 42, 0.5);
    box-shadow: 0px 0px 44px 0px rgb(7, 148, 42, 0.13) inset, 0px 2px 10px 0px rgba(0, 0, 0, 0.06);

    &.isV2 {
      border: 1px solid var(--upgrade);
      box-shadow: none;
    }

    .eventPreview,
    .eventHeader {
      opacity: 0.4;
    }
  }

  &.warning {
    border: 1px solid rgba(255, 221, 31, 0.7);
    box-shadow: 0px 0px 44px 0px rgba(255, 221, 31, 0.15) inset, 0px 2px 10px 0px rgba(0, 0, 0, 0.06);
  }

  a {
    width: 100%;
    height: 100%;
  }

  .statusPillContainer {
    position: absolute;
    bottom: 8px;
    left: 8px;
    display: flex;
    gap: 2px;
    align-items: center;
  }

  .statusCornerContainer {
    width: min-content;
    z-index: 1;

    [data-autopilot-system-redesign='on'] & {
      border: 1px solid var(--dark-4);
      border-radius: 16px;
      z-index: 2;

      &.isV2 {
        width: auto;
      }
    }
  }

  .aiVideoHeader {
    background: rgba(182, 75, 248, 0.15);
  }

  .eventHeader {
    display: flex;
    height: 32px;
    padding: 8px;
    align-content: center;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 7px 7px 0 0;

    span {
      color: var(--dark-80);
    }
  }

  .eventPreview {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: var(--inner-preview-width, 100%);
    border-radius: 0 0 7px 7px;

    .previewHeader {
      display: flex;
      align-items: center;
      background: var(--light-100);
      padding: 6px;
      width: 100%;
      justify-content: space-between;
    }
  }

  .eventImage {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    height: calc(var(--inner-preview-width) * (var(--aspect-h, 1) / var(--aspect-w, 1)));
    width: var(--inner-preview-width);

    &.isLoading {
      height: calc(
        var(--card-width) * (var(--aspect-h, 1) / var(--aspect-w, 1)) + var(--caption-top-offset, 0px) +
          var(--caption-bottom-offset, 0px)
      );
    }

    .contentImage {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .hidden {
      display: none;
    }

    .emptyContainer {
      height: 100%;
      padding: 0 5px;
      max-width: 105px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }

    .videoDuration {
      bottom: 8px;
      right: 10px;
      padding: 4px 8px;
      gap: 4px;

      .videoDurationText {
        @include sm-sohne;
      }
    }

    .videoDurationBottom {
      font-weight: 600;
      font-size: 12px;
      border-radius: 99px;
      padding: 4px 8px;

      @media (max-width: $xxLargeDevicesMinWidth) {
        display: none;
      }
    }

    .playButtonOverlay {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: var(--dark-80);
      border-radius: 50%;
      width: 42px;
      height: 42px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--light-100);
      z-index: 2;
      pointer-events: none;

      svg {
        fill: var(--light-100);
      }
    }

    .carouselIcon {
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }

  .eventTextContainer {
    padding: 0 10px 10px 10px;
    width: var(--inner-preview-width);
    background: var(--light-100);
    position: relative;
    color: var(--dark-80);
    font-family: Inter;
    font-size: 13.584px;
    font-style: normal;
    font-weight: 400;
    line-height: 152%; /* 20.648px */

    span {
      color: var(--dark-80);
      font-family: Inter;
      font-size: 12px !important;
      font-style: normal;
      font-weight: 400;
      line-height: 123% !important; /* 14.76px */
    }
  }

  .eventPreviewContent {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: var(--inner-preview-width);
  }
}

.loadingColorState {
  @include blur(10px);
  opacity: 0.4;
  background: linear-gradient(180deg, var(--light-100) 0%, var(--brand-kit-color) 100%);
  height: calc(
    var(--card-width, 100%) * (var(--aspect-h, 1) / var(--aspect-w, 1)) + var(--caption-top-offset, 0px) +
      var(--caption-bottom-offset, 0px)
  );
  width: var(--card-width);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;

  &.hasStepData,
  &.hasReferenceImage {
    opacity: 1;
    background: var(--dark-4);
    backdrop-filter: none;
  }

  .referenceImage {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: blur(20px);
    opacity: 0.9;
    transform: scale(1.1);
  }

  .progressBar {
    width: 70px;
    height: 7px;
    background-color: var(--dark-15);
    border-radius: 50px;
    padding: 1px;

    .progress {
      background-color: var(--light-100);
      border-radius: 50px;
      height: 5px;
    }
  }
}

.loading {
  aspect-ratio: var(--aspect-ratio);
  width: var(--card-width);
  border-radius: 7px 7px 0 0;
}

.hoverContainer {
  @include transition;
  width: 100%;
  height: 100%;
  position: absolute;
  background: var(--light-60);
  border-radius: 7px;
  z-index: 1;
  opacity: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  pointer-events: none;
  cursor: pointer;

  &.postIsCreating {
    cursor: default;
  }

  &.isSelected {
    box-shadow: 0 0 0 3px var(--selected-fill) inset;
    opacity: 1;

    [data-autopilot-system-redesign='on'] & {
      box-shadow: 0 0 0 2px var(--selected-fill) inset;
    }
  }

  .hoverAction {
    width: 100%;
    background: var(--light-100);
    border-radius: 4px;
  }

  &.isHovered {
    opacity: 1;
    pointer-events: auto;
    background: var(--dark-15);

    &.isLoading {
      background-color: var(--dark-10);
    }
  }

  &.isSelectView {
    opacity: 1;
    background: var(--dark-15);
    pointer-events: auto;
  }

  .hoverContainerWrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;

    &.useLink {
      height: initial;
    }
  }

  .hoverActionsContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    width: 100%;
    padding: 15px;
  }
}

// Home "Upcoming posts" variant: a single Preview pill centered over the card on hover.
.centeredPreviewOverlay {
  justify-content: center;

  .centeredPreviewButton {
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.16);
  }
}
.checkboxContainer {
  @include card-shadow;
  position: absolute;
  left: 8px;
  top: 40px;
  cursor: pointer;
  border-radius: 4px;
  z-index: 2;

  svg {
    cursor: pointer;
  }
}

.threeDotMenuContainer {
  position: absolute;
  right: 8px;
  top: 40px;
  z-index: 2;
}

.captionContainer {
  padding: 8px;
  margin: 0 auto;
  width: var(--inner-preview-width);
  background: var(--light-100);
  position: relative;
  color: var(--dark-80);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 137%; /* 16.44px */

  &.textAboveImage {
    padding-top: 0;
    padding-bottom: 6px;
  }
}

.connectBadge {
  cursor: pointer;
}

/* stylelint-disable-next-line scss/media-feature-value-dollar-variable */
@media (max-width: 1440px) {
  .eventContainer {
    width: var(--card-width);

    .loadingColorState {
      width: var(--card-width);
    }
  }
}

/* stylelint-disable-next-line scss/media-feature-value-dollar-variable */
@media (max-width: 1440px) {
  .captionContainer {
    width: var(--inner-preview-width);
  }
}

.hasInnerPreview {
  background: var(--dark-2);

  &.innerPreviewV2 {
    height: 100%;
  }

  .eventImage.isLoading {
    height: var(--card-height, auto);
    width: 100%;
    border-top: none;
  }

  .eventHeader {
    background: var(--light-100);

    &.innerPreviewV2 {
      background: transparent;
      padding: 12px 12px 2px 12px;
    }
  }
}

.innerEventPreview {
  width: var(--inner-preview-width);
  min-width: var(--inner-preview-width);

  &.innerPreviewV2 {
    padding: 8px 0;

    .eventPreviewContent {
      box-shadow: 0 2px 23px 0 rgba(0, 0, 0, 0.08);
      border-radius: 5px;
      overflow: hidden;

      .captionContainer {
        padding: 8px;
        font-size: 11px;
      }
    }

    .innerPreviewLoadingShimmerer {
      width: 100%;
      height: 100%;

      .eventImage {
        justify-content: center;

        .loadingColorState {
          height: 100%;
          width: 100%;
        }
      }

      .hasReferenceImage {
        width: 100%;
      }
    }
  }

  .eventPreviewContent {
    height: var(--card-height, auto);
    width: var(--inner-preview-width);
    min-width: var(--inner-preview-width);

    .captionContainer {
      padding: 5.66px;
      font-size: 10px;
    }

    .emptyContainer {
      height: var(--card-height, auto);
    }
  }
}

.innerPreviewLoadingShimmerer {
  box-shadow: 0 4.651px 8.139px 0 rgba(0, 0, 0, 0.03);
  border: 1px solid var(--dark-4);
  border-top: none;
  border-radius: 7px !important;
  background: var(--light-60);
}

.loadingInnerPreview {
  height: var(--card-height, auto) !important;
  width: 100% !important;

  &.innerPreviewV2 {
    width: var(--inner-preview-width) !important;
  }

  .eventPreviewContent {
    height: 100%;
    width: 100%;

    .eventImage {
      height: 100%;
      width: 100%;
      min-width: 100%;
    }
  }
}

.timeDateContainer {
  min-width: 92px;
}

.innerDocEventPreview {
  &.loadingInnerPreview {
    height: var(--card-height, auto);

    .eventPreviewContent {
      height: 100%;

      .eventImage {
        height: 100%;
        width: var(--inner-preview-width);
        min-width: var(--inner-preview-width);
      }
    }
  }

  .eventPreviewContent {
    height: var(--card-height, auto);
    width: var(--inner-preview-width);
    min-width: var(--inner-preview-width);
  }

  .eventImage {
    width: calc(var(--card-width) - 20px);
    height: calc(var(--card-height) - 20px);

    .eventTextContainer {
      padding: 10px;
      width: calc(var(--card-width) - 20px);
      height: calc(var(--card-height) - 20px);
      border-radius: 10px;
      box-shadow: 0 4.651px 8.139px 0 rgba(0, 0, 0, 0.03);
    }
  }
}
